import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalLayoutComponent } from "./ui/modal/modal-layout.component";
import { DropdownLayoutComponent } from "./ui/dropdown/dropdown-layout.component";
import { NotifyQueueComponent } from "./ui/notify";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalLayoutComponent, DropdownLayoutComponent, NotifyQueueComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class App {
}
